export const getFirstValueDifference = (oldValue: string, newValue: string): string => {
    let index = 0;

    while (index < newValue.length) {
        const newValueChar = newValue[index];
        if (oldValue[index] !== newValueChar) {
            return newValueChar;
        }

        index++;
    }

    return '';
};
